import React, { useState } from "react";
import { useLang } from "@/i18n";
import { TrendingDown } from "lucide-react";

const SAVINGS_RATE = 0.15; // typische OTA-Gebühr/Aufschlag (Portalgebühren + Servicegebühren)

export function SavingsCalculator() {
  const { lang } = useLang();
  const [nights, setNights] = useState(3);
  const [pricePerNight, setPricePerNight] = useState(89);

  const otaTotal = nights * pricePerNight;
  const directTotal = Math.round(otaTotal * (1 - SAVINGS_RATE));
  const savings = otaTotal - directTotal;

  const t = (de, en) => (lang === "de" ? de : en);

  return (
    <div className="bg-white rounded-[28px] border border-[var(--warm)] p-6 md:p-10 shadow-[0_16px_48px_rgba(19,22,15,0.06)]">
      <div className="grid md:grid-cols-2 gap-8 md:gap-12 items-center">
        {/* Inputs */}
        <div>
          <div className="flex items-center gap-2 mb-1">
            <TrendingDown size={16} className="text-[var(--terra)]" />
            <span className="tag">{t("spar-rechner", "savings calculator")}</span>
          </div>
          <h3 className="font-display text-2xl md:text-3xl font-medium mb-6 text-[var(--ink)]">
            {t("Direkt buchen, sofort sparen", "Book direct, save instantly")}
          </h3>

          <div className="mb-6">
            <div className="flex justify-between text-sm mb-2">
              <span className="text-[var(--muted)]">{t("Nächte", "Nights")}</span>
              <span className="font-semibold text-[var(--ink)]">{nights}</span>
            </div>
            <input
              type="range" min="1" max="21" value={nights}
              onChange={(e) => setNights(Number(e.target.value))}
              className="w-full accent-[var(--terra)]"
            />
          </div>

          <div>
            <div className="flex justify-between text-sm mb-2">
              <span className="text-[var(--muted)]">
                {t("Preis/Nacht auf Booking.com/Airbnb", "Price/night on Booking.com/Airbnb")}
              </span>
              <span className="font-semibold text-[var(--ink)]">€{pricePerNight}</span>
            </div>
            <input
              type="range" min="40" max="250" step="5" value={pricePerNight}
              onChange={(e) => setPricePerNight(Number(e.target.value))}
              className="w-full accent-[var(--terra)]"
            />
          </div>

          <p className="text-xs text-[var(--muted)] mt-5 leading-relaxed">
            {t(
              "Geschätzte Ersparnis basierend auf typischen Portal-/Servicegebühren (ca. 15%), die bei einer Direktbuchung entfallen.",
              "Estimated savings based on typical portal/service fees (~15%) that don't apply when booking directly."
            )}
          </p>
        </div>

        {/* Result */}
        <div className="bg-[var(--warm)] rounded-[20px] p-6 md:p-8">
          <div className="flex items-center justify-between text-sm mb-3 text-[var(--muted)]">
            <span>Booking.com / Airbnb</span>
            <span className="line-through">€{otaTotal}</span>
          </div>
          <div className="flex items-center justify-between text-sm mb-5">
            <span className="font-semibold text-[var(--ink)]">Atlas Apartment {t("(direkt)", "(direct)")}</span>
            <span className="font-display text-2xl font-medium text-[var(--sage)]">€{directTotal}</span>
          </div>
          <div className="bg-[var(--terra)] text-white rounded-2xl px-5 py-4 text-center">
            <p className="text-xs uppercase tracking-wide text-white/70 mb-1">
              {t("Deine Ersparnis", "Your savings")}
            </p>
            <p className="font-display text-3xl md:text-4xl font-semibold">€{savings}</p>
          </div>
        </div>
      </div>
    </div>
  );
}
